export var isOfficeRouteItem = function (url) {
    return url.route !== undefined;
};
//# sourceMappingURL=isOfficeRouteItem.js.map